import React from "react";
import Star from "./Star";
import IframeResizer from "iframe-resizer-react";

const iframeProps = {
  src: "https://embed-v2.testimonial.to/w/fotoboxguru?theme=light&card=base&loadMore=on&initialCount=10&hideDate=on&tag=all",
  style: { width: "1px", minWidth: "100%", marginBottom: "50px" },
};

function FeedbackSection(props) {
  return (
    <>
      <div className="text-center flex flex-col" id="bewertungen">
        <h2 className="text-[26px] leading-8 font-bold">
          Was unsere Kunden sagen
        </h2>
      </div>

      <IframeResizer {...iframeProps} />

      {/* 
        <div className="w-full max-w-6xl mx-auto">
           
            <div className="-mx-3 md:flex items-start">
                <div className="px-3 md:w-1/3 text-slate-900 text-[16px]">
                    <div className="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 font-light mb-6">
                        <div className="w-full flex mb-4 items-center">
                            
                            <div className="flex-grow">
                                <h6 className="font-bold">Ralph</h6>
                            </div>
                            
                            <Star stars={5} />

                        </div>
                        <div className="w-full">
                            <p><span className="text-lg leading-none italic font-bold mr-1 text-[#FF5744]">"</span>Es hat alles bestens funktioniert. Die Kamera war zum zugesagten Zeitpunkt rechtzeitig bei mir. Das Gerät hatte einen sehr guten Zustand und die Rückerstattung des Geldes für die nicht genutzten Filme war auch einwandfrei. Die Kommunikation war verbindlich und sehr freundlich. Alles in allem: topp, sehr empfehlenswert!!<span className="text-lg leading-none italic font-bold text-[#FF5744] ml-1">"</span></p>
                        </div>
                    </div>
                    <div className="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 font-light mb-6">
                        <div className="w-full flex mb-4 items-center">
                            
                            <div className="flex-grow">
                                <h6 className="font-bold">Tom</h6>
                            </div>
                            
                            <Star stars={5} />

                        </div>
                        <div className="w-full">
                            <p><span className="text-lg leading-none italic font-bold mr-1 text-[#FF5744]">"</span>Wir haben die Sofortbildkamera für unsere Hochzeit gemietet. Der Versand erfolgte prompt und die Abwicklung war unkompliziert.<span className="text-lg leading-none italic font-bold text-[#FF5744] ml-1">"</span></p>
                        </div>
                    </div>
                </div>
                <div className="px-3 md:w-1/3 text-slate-900 text-[16px]">
                    <div className="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 font-light mb-6">
                        <div className="w-full flex mb-4 items-center">
                            
                            <div className="flex-grow">
                                <h6 className="font-bold">Lisa</h6>
                            </div>
                            
                            <Star stars={5} />

                        </div>
                        <div className="w-full">
                            <p><span className="text-lg leading-none italic font-bold mr-1 text-[#FF5744]">"</span>Die Polaroid Kamera war perfekt für unsere Hochzeit! Der Versand war super schnell, und die Abwicklung verlief reibungslos. Die Gäste hatten eine Menge Spaß beim Fotografieren und die Sofortbilder waren eine tolle Ergänzung für unser Gästebuch.<span className="text-lg leading-none italic font-bold text-[#FF5744] ml-1">"</span></p>
                        </div>
                    </div>
                    <div className="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 font-light mb-6">
                        <div className="w-full flex mb-4 items-center">
                            
                            <div className="flex-grow">
                                <h6 className="font-bold">Tülin</h6>
                            </div>
                            
                            <Star stars={5} />

                        </div>
                        <div className="w-full">
                            <p><span className="text-lg leading-none italic font-bold mr-1 text-[#FF5744]">"</span>Es war für einen Geburtstag und daher an dem Tag stressig. Ich bin eig sehr technikversiert aber hab nicht verstanden, dass es manuell durch eine Drehbewegung eingeschaltet wird. Hab mich moniert aber FotoboxGuru hat ruhig reagiert 😅 danke Gerne wieder ❤️😉 nächste Party lässt nicht lange auf sich warten.<span className="text-lg leading-none italic font-bold text-[#FF5744] ml-1">"</span></p>
                        </div>
                    </div>
                </div>
                <div className="px-3 md:w-1/3 text-slate-900 text-[16px]">
                    <div className="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 font-light mb-6">
                        <div className="w-full flex mb-4 items-center">
                            
                            <div className="flex-grow">
                                <h6 className="font-bold">Andrea</h6>
                            </div>
                            
                            <Star stars={5} />

                        </div>
                        <div className="w-full">
                            <p><span className="text-lg leading-none italic font-bold mr-1 text-[#FF5744]">"</span>Hat alles prima geklappt, wir haben schöne Fotos gemacht und hatten viel Spaß.<span className="text-lg leading-none italic font-bold text-[#FF5744] ml-1">"</span></p>
                        </div>
                    </div>
                    <div className="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 font-light mb-6">
                        <div className="w-full flex mb-4 items-center">
                            
                            <div className="flex-grow">
                                <h6 className="font-bold">David</h6>
                            </div>
                            
                            <Star stars={5} />

                        </div>
                        <div className="w-full">
                            <p><span className="text-lg leading-none italic font-bold mr-1 text-[#FF5744]">"</span>Wir nutzten die Polaroid Sofortbildkamera für das Hochzeitsgästebuch. Schneller Versand, einfache Abwicklung. Das Brautpaar liebte die persönlichen Nachrichten und die Sofortbilder als bleibende Erinnerung. Eine tolle Idee!<span className="text-lg leading-none italic font-bold text-[#FF5744] ml-1">"</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
*/}
    </>
  );
}

export default FeedbackSection;
